export function readCommunityCookie(): {
  id: string | null
  slug: string | null
  name: string | null
} {
  if (typeof document === 'undefined')
    return { id: null, slug: null, name: null }
  const map = Object.fromEntries(
    document.cookie.split(';').map((part) => {
      const [k, ...rest] = part.trim().split('=')
      return [k, decodeURIComponent(rest.join('=') || '')]
    }),
  )
  return {
    id: map.orbyt_community_id || null,
    slug: map.orbyt_community_slug || null,
    name: map.orbyt_community_name || null,
  }
}
